
import React from 'react'
import { Drawer, List } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import ListItem from './ListItem';
import OpenElement from './OpenElement';
import Logo from './Logo';
import ListAddButton from './ListAddButton';
import LogoutButton from './LogoutButton';
import { setMenuOpen, setInnerMenuOpen } from 'redux/actions'
import { connect } from 'react-redux'

import GroupWorkIcon from '@material-ui/icons/GroupWork';
import StarIcon from '@material-ui/icons/Star';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import PublicIcon from '@material-ui/icons/Public';
import DescriptionIcon from '@material-ui/icons/Description';
import GavelIcon from '@material-ui/icons/Gavel';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

const style = theme => ({
	paper: {
		justifyContent: 'space-between',
		borderRightColor: theme.palette.border.onlyContrast ? theme.palette.border.onlyContrast : undefined
	},
	drawerOpen: {
		width: theme.components.navigation.width,
		transition: theme.transitions.default.open('width'),
		overflowX: 'hidden',
	},
	drawerClose: {
		transition: theme.transitions.default.close('width'),
		overflowX: 'hidden',
		width: theme.spacing(7) + 1,
	},
	innerListItem: {
		paddingLeft: theme.spacing(3),
	}
})

function Navigation({
	purchaser,
	classes,
	isMenuOpen,
	setMenuOpen,
	innerMenu,
	setInnerMenuOpen,
	navElements
}) {

	const icons = {
		my_demands: StarIcon,
		purchasingGroups: GroupWorkIcon,
		all_demands: ShoppingCartIcon,
		deputy: PeopleIcon,
		public_area: PublicIcon,
		edocument: DescriptionIcon,
		auction: GavelIcon,
		intranet: LocalLibraryIcon,
		report: InsertDriveFileIcon,
		administration: HowToRegIcon,
		contractor_area: MonetizationOnIcon,
		annualReport: AssessmentIcon,
		audit: PlaylistAddCheckIcon
	}

	return (
		<Drawer
			variant="permanent"
			open={isMenuOpen}
			classes={{
				paper: clsx(classes.paper, {
					[classes.drawerOpen]: isMenuOpen,
					[classes.drawerClose]: !isMenuOpen,
				}),
			}}
		>
			<List>
				<Logo
					purchaser={purchaser}
					open={isMenuOpen}
				/>

				<OpenElement
					open={isMenuOpen}
					setOpen={setMenuOpen}
					setInnerMenuOpen={setInnerMenuOpen}
				/>

				{navElements && navElements.newDemandProcedures && <ListAddButton
					open={isMenuOpen}
					procedures={navElements.newDemandProcedures}
				/>}

				{navElements && navElements.elements.map((item, i) => (

						item.href ?
							<ListItem
								key={i}
								{...item}
								openInner={isMenuOpen}
							/> :
							<React.Fragment key={i}>
								<ListItem
									{...item}
									setInnerMenuOpen={setInnerMenuOpen}
									innerMenu={innerMenu}
									openInner={isMenuOpen}
									innerKey={item.key.split(".")[1]}
									singleLink={item.menuElementList.length === 1 && item.menuElementList[0].url}
									Icon={icons[item.key.split(".").pop()]}
									setMenuOpen={setMenuOpen}
								/>
								{
									(innerMenu[item.key.split(".")[1]] &&
										item.menuElementList.length > 1)
									&&
									item.menuElementList.map((innerItem, j) => {
										return (
											<ListItem
												key={j}
												className={classes.innerListItem}
												openInner={isMenuOpen}
												{...innerItem}
											/>)
									})}
							</React.Fragment>
					))}
			</List>
			<LogoutButton />
		</Drawer>
	)
}

export default connect((state) => ({
	isMenuOpen: state.store.isMenuOpen,
	innerMenu: state.innerMenu,
	navElements: state.resources.userLoggedMenuList
}), {
		setMenuOpen,
		setInnerMenuOpen
	})(withStyles(style)(Navigation));
